// src/api/securityEmployeeQuestionApi.js
import apiClient from './axios';

const securityEmployeeQuestionApi = {
  // GET all (with pagination + search)
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/password-questions/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // CREATE
  create: async (data) => {
    const response = await apiClient.post('/password-questions/', data);
    return response.data;
  },

  // UPDATE
  update: async (id, data) => {
    const response = await apiClient.put(`/password-questions/${id}/`, data);
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/password-questions/${id}/`);
    return id;
  },
};

export default securityEmployeeQuestionApi;